module.exports = __webpack_public_path__ + "pin_light_brown.164b93.png";